document.addEventListener('click', function (e) {
    if (e.target.closest('.toggle-coworker-info')) {
        if (e.target.closest('.coworker-card').classList.contains('active')) {
            e.target.closest('.coworker-card').classList.remove('active')
        } else {
            e.target.closest('.coworker-card').classList.add('active')
        }
    }
})
